import { getLocaleCookie, removeLocaleCookie, setLocaleCookie, } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { supportedLocales } from '#pplx/frontend/i18n/core.js';
import { DEFAULT_LOCALE } from '#pplx_generated/pplx/frontend/i18n/localeInfo.generated.js';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
// Single-file event: defined here at its only call site rather than in a shared package.
const setLocaleCookieEvent = EVENT_PAYLOAD;
/**
 * Only use this hook when interacting with app settings locale components
 * This hook does not consider browser locale (via accept-language header)
 * Use "useLocale()" from "next-intl", which respects both
 * browser locale (via header) + application settings locale (via cookie)
 */
export function useChosenLocale() {
    const { track } = useInstrumentation();
    const { locale: nextLocale } = useIntl();
    const [locale, setLocale] = useState(supportedLocales.includes(nextLocale) ? nextLocale : DEFAULT_LOCALE);
    const localeCookie = getLocaleCookie();
    if (localeCookie) {
        // If the cookie is malformed, remove it
        if (!supportedLocales.includes(localeCookie)) {
            removeLocaleCookie();
        }
        // If the local locale version doesn't match that specified by the cookie
        else if (locale !== localeCookie) {
            setLocale(localeCookie);
        }
    }
    else {
        // If there's no locale cookie and the local state doesn't match the locale
        // detected by next, update it
        if (locale !== nextLocale && supportedLocales.includes(nextLocale)) {
            setLocale(nextLocale);
        }
    }
    return useMemo(() => ({
        locale,
        hasChosenLocale: !!localeCookie,
        saveLocale(newLocale) {
            setLocale(newLocale);
            setLocaleCookie(newLocale);
            track(setLocaleCookieEvent({ name: 'set locale cookie', data: { locale: newLocale } }));
        },
    }), [locale, localeCookie, track]);
}
//# sourceMappingURL=useChosenLocale.js.map